import {
    UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN,
    UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS,
    UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE,
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';
  
const PATCHED_COMMENT_KEY  = "patchedComment";
const FEED_ID_KEY          = "feedId";
const COMMENT_ID_PARAMETER = "commentId";

export function updateCrawledCommentsIsSarcasmManuallyToggled(props = {}) {
    return dispatch => {
        dispatch({
            type: UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN,
        });
        const url = `${apiEndPoints.comments.UPDATE_COMMENT_IS_SARCASM_MANUALLY_TOGGLED}?commentId=${props.commentId}&isSarcasmManuallyToggled=${props.isSarcasmManuallyToggled}`;
        const promise = new Promise((resolve, reject) => {
            const doRequest = http.patch(url);
            doRequest.then(
                res => {
                    dispatch({
                        type: UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS,
                        data: res.data,
                    });
                    resolve(res);
                },
                err => {
                    dispatch({
                        type: UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE,
                    });
                    reject(err);
                },
            );
        });
        return promise;
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_BEGIN:
            return {
                ...state,
                updateCrawledCommentsIsSarcasmManuallyToggledBegin: true,
                updateCrawledCommentsIsSarcasmManuallyToggledSuccess: false,
                updateCrawledCommentsIsSarcasmManuallyToggledFailure: false,
                updateTweetsIsSarcasmManuallyToggledSuccess: false,
                updateTweetsIsSarcasmManuallyToggledFailure: false,
                updateUploadedCommentsIsSarcasmManuallyToggledSuccess: false,
                updateUploadedCommentsIsSarcasmManuallyToggledFailure: false,
                commentOrTweetAfterToggling: null
            };
        case UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_SUCCESS: {
            const updatedComments = state.allComments.data.map(comment => {
                if (comment.commentId === action.data.data[PATCHED_COMMENT_KEY][COMMENT_ID_PARAMETER]) {
                    comment = action.data.data[PATCHED_COMMENT_KEY];
                }
                return comment;
            });
            state.allComments.data = updatedComments;
            if (state.feedDetails.data) {
                const updatedFeedModalComments = state.feedDetails.data.map(comment => {
                    if (comment.commentId === action.data.data[PATCHED_COMMENT_KEY][COMMENT_ID_PARAMETER]) {
                        comment = action.data.data[PATCHED_COMMENT_KEY];
                    }
                    return comment;
                });
                state.feedDetails.data = updatedFeedModalComments;
            }
            const commentAfterToggling = action.data.data[PATCHED_COMMENT_KEY]
            commentAfterToggling[FEED_ID_KEY] = action.data.data[FEED_ID_KEY]
            return {
                ...state,
                updateCrawledCommentsIsSarcasmManuallyToggledBegin: false,
                updateCrawledCommentsIsSarcasmManuallyToggledSuccess: true,
                commentOrTweetAfterToggling: commentAfterToggling
            };
        }
        case UPDATE_CRAWLED_COMMENTS_IS_SARCASM_MANUALLY_TOGGLED_FAILURE:
            return {
                ...state,
                updateCrawledCommentsIsSarcasmManuallyToggledBegin: false,
                updateCrawledCommentsIsSarcasmManuallyToggledFailure: true,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/home/redux/updateCrawledCommentsIsSarcasmManuallyToggled.js